import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule, NgClass, NgStyle } from '@angular/common';
import { AuthService } from '../../service/auth.service';
import { Usuario } from '../../model/usuario/usuario.model';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { IconeModuloUtils } from '../../util/icone-modulo.utils';

@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [
    NgStyle,
    MatTooltip,
    RouterLink,
    NgClass,
    CommonModule
  ],
  providers: [
    AuthService
  ],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.css'
})
export class SideMenuComponent implements OnInit, OnChanges {

  opened = false;
  openedRotina = false;
  usuarioLogado: Usuario = new Usuario();
  modulos: any[] = [];
  moduloSelecionado: any = null;
  rotinaSelecionada: any = null;
  trocouRotina = false;

  @Input() isMobile = true;
  @Input() openMenu = true;
  @Output() menuOpenChange = new EventEmitter<boolean>();

  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  ngOnInit() {
    this.usuarioLogado = this.authService.getUsuarioLogado();
    this.modulos = this.authService.getModulos;

    for (const modulo of this.modulos) {
      for (const rotina of modulo.rotinas) {
        if (window.location.pathname.includes(rotina.url)) {
          this.moduloSelecionado = modulo;
          this.rotinaSelecionada = rotina;
          break;
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['openMenu']) {
      if (this.openMenu == false) {
        this.opened = false;
        this.openedRotina = false;
        if(this.trocouRotina){
          this.trocouRotina = false
        }
      }
    }
  }

  iconeModulo(iconeModulo: string, selecionado: boolean): string {
    return IconeModuloUtils.caminho(iconeModulo, selecionado ? '-selecionado' : '');
  }

  verificarSeUmaRotina(modulo: any) {
    if (modulo.rotinas.length > 1) {
      this.selecionarModulo(modulo);
    } else if (modulo.rotinas.length == 1) {
      this.moduloSelecionado = modulo;
      this.rotinaSelecionada = modulo.rotinas[0];
      this.router.navigate([modulo.rotinas[0].url]);
      this.openedRotina = false;
      this.trocouRotina = true
      this.menuOpenChange.emit(this.openedRotina);
    }
  }

  selecionarModulo(modulo: any) {
    const toggleOpened = !this.isMobile;

    if (!this.moduloSelecionado) {
      this.openedRotina = true;
      if (toggleOpened) this.opened = true;
      this.moduloSelecionado = modulo;
    } else if (this.moduloSelecionado.idModulo !== modulo.idModulo) {
      this.moduloSelecionado = modulo;
      this.openedRotina = true;
      if (toggleOpened) this.opened = true;
    } else if (this.moduloSelecionado.idModulo === modulo.idModulo) {
      this.openedRotina = !this.openedRotina;
      if (toggleOpened) this.opened = this.openedRotina;
    }
    this.menuOpenChange.emit(this.openedRotina);
  }

  redirecionar() {
    this.router.navigate([`/usuario-perfil`]);
    this.openedRotina = false;
    this.menuOpenChange.emit(this.openedRotina);
  }

  selectRotina(rotina: any) {
    this.opened = false;
    this.openedRotina = false;
    this.rotinaSelecionada = rotina;
    this.router.navigate([rotina.url]);
    this.trocouRotina = true
    this.menuOpenChange.emit(this.openedRotina);
  }

  setMenuOpen(isOpen: boolean) {
    this.openedRotina = isOpen;
    this.menuOpenChange.emit(this.openedRotina);
  }
}
